import React, { Fragment } from "react";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import * as R from "ramda";

import { Field } from "../../components/controls/FormikForm";
import Users from "../../components/inputs/Users";

const TeamUsersForm = ({ t, users, ownerId }) => (
  <Fragment>
    <Field name="users" label={t("team:users")}>
      <Users ownerId={ownerId} users={users} />
    </Field>
  </Fragment>
);

export default compose(
  withTranslation(["team"]),
  connect((state, { ownerId }) => ({
    users: R.pipe(
      R.pathOr([], ["company", "users"]),
      // Only keep owner and non-admin users
      R.filter(
        R.either(
          R.propEq("id", ownerId),
          R.complement(
            R.propSatisfies(
              R.either(R.includes("headadmin"), R.includes("admin")),
              "roles"
            )
          )
        )
      ),
      // Remove connected user if it's not the owner
      R.reject(
        R.both(
          R.complement(R.propEq("id", ownerId)),
          R.propEq("id", R.path(["user", "id"], state))
        )
      )
    )(state)
  }))
)(TeamUsersForm);
